import { ChangeDetectorRef, Component, Input, OnInit, OnChanges, SimpleChanges, ElementRef } from '@angular/core';
import { ApiProspectsService } from 'src/app/services/ApiProspects/api-prospects.service';
import { TranslateService } from '@ngx-translate/core';

// ✅ declare $ so DataTable() is recognized
declare let $: any;

@Component({
  selector: 'app-contrat-fiche',
  templateUrl: './contrat.component.html',
  styleUrls: ['./contrat.component.css'],
})
export class ContratComponent implements OnInit, OnChanges {
  listContrats: any[] = [];
  listSociete: any[] = [];
  societeContrats: { [key: string]: any[] } = {}; // store contrats by societe id
  societePage: { [key: string]: number } = {};
  societePageSize: { [key: string]: number } = {};
  dataTable: any; // ✅ already defined
  societeExpanded: { [key: number]: any } = {};
  formInfoHolder: { key: string; value: string }[] = [{ key: '', value: '' }];

  listkeys: any;

  listData: any;
  listDataSociete: any;

  show_loading_add: boolean = false;
  @Input() prospect: string = '';
  miniListing: any;
  affaire: any;

  expandedElement: any = null;

  constructor(
    private apiProspectService: ApiProspectsService,
    private chRef: ChangeDetectorRef,
    private translate: TranslateService,
    private el: ElementRef
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.getContrats(this.prospect);
  }

  page = 1;
  pageSize = 10;

  get paginatedContrats() {
    const start = (this.page - 1) * this.pageSize;
    const end = start + this.pageSize;
    return this.listContrats?.slice(start, end) || [];
  }

  public stopClickPropagation(event: Event): void {
    event.stopPropagation();
  }

  get totalPages() {
    return this.listContrats?.length ? Math.ceil(this.listContrats.length / this.pageSize) : 1;
  }

  get totalItems() {
    return this.listContrats?.length || 0;
  }

  ngOnInit(): void {
    this.translate.onLangChange.subscribe(() => {
      this.translate.get('languages').subscribe((object: any) => {
        this.miniListing = object.miniListing;
        this.getContrats(this.prospect);
      });
    });

    this.translate.get('languages').subscribe((object: any) => {
      this.affaire = object.affaire;
      this.listkeys = [
        { name: 'num_contrat', title: this.affaire.nContrat },
        { name: 'montant', title: this.affaire.solde },

        { name: 'cmp', title: this.affaire.compagnie },
        { name: 'risque', title: this.affaire.ligneproduit },
        { name: 'etat', title: object.listing.Statut },

        // add more keys here
      ];
    });

    this.translate.get('languages').subscribe((object: any) => {
      this.miniListing = object.miniListing;
      this.getContrats(this.prospect);
    });
  }

  onSearch(searchTerm: string) {
    // Convert array of {key, value} into { key: value, ... }
    const body = this.formInfoHolder
      .filter((f) => f.key && f.value)
      .reduce((acc: any, f) => {
        acc[f.key] = f.value;
        return acc;
      }, {});

    this.loaderInfo = true;
    this.getContrats(this.prospect, body);
  }

  // Paginate société contrats
  getPaginatedSocieteContrats(socId: string) {
    const page = this.societePage[socId] || 1;
    const size = this.societePageSize[socId] || 10;
    const start = (page - 1) * size;
    return this.societeContrats[socId]?.slice(start, start + size) || [];
  }

  getSocieteTotalPages(socId: string) {
    const size = this.societePageSize[socId] || 10;
    const total = this.societeContrats[socId]?.length || 0;
    return Math.max(1, Math.ceil(total / size));
  }

  // Search inside société
  onSocieteSearch(socId: string, term: string) {
    this.apiProspectService.getSocietecontratsImpayes(socId, term).subscribe(
      (data: any) => {
        this.listDataSociete = data;
        this.societeContrats[socId] = data.list_contrats || [];
        this.societePage[socId] = 1;
        this.societePageSize[socId] = 10; // reset to first page
      },
      (error: any) => {
        console.error(error);
        this.show_loading_add = false;
      }
    );
  }
  // pagination soc

  // ================= SOCIETE PAGINATION ===================

  /** Ensure defaults exist for a given soc id */
  private ensureSocietePagingDefaults(socId: string) {
    if (!this.societePage[socId]) this.societePage[socId] = 1;
    if (!this.societePageSize[socId]) this.societePageSize[socId] = 10;
    this.societePage[socId] = Number(this.societePage[socId]);
    this.societePageSize[socId] = Number(this.societePageSize[socId]);
  }

  loaderInfo = false;
  isDropdownVisible = false;

  setValues(index: number, field: 'key' | 'value', event: any) {
    this.formInfoHolder[index][field] = event.target ? event.target.value : event;
  }

  onAdd() {
    this.formInfoHolder.push({ key: '', value: '' });
  }

  deletePrspect(index: number) {
    this.formInfoHolder.splice(index, 1);
  }

  clearModal(socId: string) {
    this.formInfoHolder = [{ key: '', value: '' }];
    this.chRef.detectChanges();

    if (socId === '') {
      this.onSearch('');
    } else {
      this.OnOpen(socId);
    }
  }

  OnOpen(socId: string) {
    // Convert array of {key, value} into { key: value, ... }
    const body = this.formInfoHolder
      .filter((f) => f.key && f.value)
      .reduce((acc: any, f) => {
        acc[f.key] = f.value;
        return acc;
      }, {});

    // If there are no filters, don't call API
    // if (!Object.keys(body).length) {
    //   return;
    // }

    this.loaderInfo = true;
    this.apiProspectService.getSocietecontratsImpayes(socId, body).subscribe(
      (data: any) => {
        this.listDataSociete = data;
        this.societeContrats[socId] = data.list_contrats || [];
        this.societePage[socId] = 1;
        this.societePageSize[socId] = 10;
        this.loaderInfo = false;
        this.isDropdownVisible = false; // close popup
        const dropdownMenu = this.el.nativeElement.querySelector('.dropdown-menu.show');
        if (dropdownMenu) {
          dropdownMenu.classList.remove('show');
        }
      },
      (error: any) => {
        console.error(error);
        this.loaderInfo = false;
      }
    );
  }

  /** Return paginated items safely */

  getSocieteStart(socId: string) {
    const total = this.societeContrats[socId]?.length || 0;
    if (total === 0) return 0;
    this.ensureSocietePagingDefaults(socId);
    return (this.societePage[socId] - 1) * this.societePageSize[socId] + 1;
  }

  getSocieteEnd(socId: string) {
    const total = this.societeContrats[socId]?.length || 0;
    if (total === 0) return 0;
    this.ensureSocietePagingDefaults(socId);
    const end = this.societePage[socId] * this.societePageSize[socId];
    return Math.min(end, total);
  }

  onSocietePageSizeChange(socId: string, value: any) {
    this.societePageSize[socId] = Number(value) || 10;
    this.societePage[socId] = 1;
  }

  setSocietePage(socId: string, page: number) {
    const total = this.getSocieteTotalPages(socId);
    page = Math.min(Math.max(1, Number(page) || 1), total);
    this.societePage[socId] = page;
  }

  prevSocietePage(socId: string) {
    this.setSocietePage(socId, (this.societePage[socId] || 1) - 1);
  }

  nextSocietePage(socId: string) {
    this.setSocietePage(socId, (this.societePage[socId] || 1) + 1);
  }

  //
  onSocieteTabChange(event: any) {
    const tabIndex = event.index;
    // first tab = Individuelle, so skip if index === 0
    if (tabIndex === 0) return;

    const societe = this.listSociete[tabIndex - 1]; // -1 because first tab is Individuelle
    if (!societe) return;

    // If already loaded, don't fetch again
    if (this.societeContrats[societe.id]) return;

    this.show_loading_add = true;
    this.apiProspectService.getSocietecontratsImpayes(societe.id, '').subscribe(
      (data: any) => {
        this.listDataSociete = data;

        this.societeContrats[societe.id] = data.list_contrats || [];
        this.societePage[societe.id] = 1;
        this.societePageSize[societe.id] = 10;
        this.show_loading_add = false;
      },
      (error: any) => {
        console.error('Error fetching contrats for société:', error);
        this.show_loading_add = false;
      }
    );
  }

  showhidePop() {
    this.isDropdownVisible = !this.isDropdownVisible;
  }

  getContrats(id: string, searchTerm: string = '') {
    this.show_loading_add = true;

    this.apiProspectService.getcontratsImpayes(id, searchTerm).subscribe(
      (data: any) => {
        this.listContrats = data.list_contrats || [];
        this.listSociete = data.list_societe || [];

        this.listData = data;
        this.show_loading_add = false;
        this.loaderInfo = false;
        this.isDropdownVisible = false; // close popup
        const dropdownMenu = this.el.nativeElement.querySelector('.dropdown-menu.show');
        if (dropdownMenu) {
          dropdownMenu.classList.remove('show');
        }
        // Trigger change detection so table is rendered
        this.chRef.detectChanges();

        // Initialize DataTable after DOM update
      },
      (err: any) => {
        console.error(err);
        this.loaderInfo = false;

        this.show_loading_add = false;
      }
    );
  }

  toggleExpand(item: any, socId?: number) {
    if (socId) {
      // cas société
      this.societeExpanded[socId] = this.societeExpanded[socId] === item ? null : item;
    } else {
      // cas individuelle
      this.expandedElement = this.expandedElement === item ? null : item;
    }
  }

  generatePdf(data: any) {
    this.show_loading_add = true;
    this.apiProspectService.generatePdf(data).subscribe(
      (response: any) => {
        this.show_loading_add = false;
        const byteCharacters = atob(response.content);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
      },
      (error: any) => {
        console.error(error);
        this.show_loading_add = false;
      }
    );
  }
}
